import { wallet as c } from "../store/index.mjs";
import { useBulletContract as e } from "../store/bulletContract.mjs";
async function s(a, n) {
  const t = n ?? c?.getAddress();
  return await e(a).balanceOf(t);
}
function u(a, n, t) {
  return e(a).allowance(n, t);
}
async function f(a, n, t, r) {
  const o = {
    nonce: void 0
  };
  return r != null && (o.nonce = r), await e(a, !0).approve(
    n,
    t,
    o
  );
}
export {
  u as allowance,
  f as approve,
  s as balanceOf
};
//# sourceMappingURL=bullet.mjs.map
